<template>
  <div :class="btnStyle(loading, disabled)" @click="handleClick">
    <div v-if="!loading"><slot></slot></div>
    <div v-else>{{ loadingText }}</div>
  </div>
</template>

<script setup>
const btnStyle = (loading, disabled) => {
  if (disabled) {
    return "_comp_button _comp_button_disabled";
  }
  if (loading) {
    return "_comp_button _comp_button_loading";
  } else {
    return "_comp_button";
  }
};
const props = defineProps({
  loading: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  width: {
    type: Number || String,
    default: 190,
  },
  height: {
    type: Number || String,
    default: 40,
  },
  loadingText: {
    type: String,
    default: "Loading...",
  },
});

const emit = defineEmits(["click"]);

const handleClick = () => {
  if (props?.loading || props?.disabled) {
    return;
  }
  emit("click");
};
</script>

<style scoped lang="less">
._comp_button {
  width: 190px;
  height: 40px;
  background-color: #ef1e0b;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  &_loading {
    opacity: 0.5;
    cursor: not-allowed !important;
  }
  &_disabled {
    background-color: #ccc;
    cursor: not-allowed !important;
  }
}
</style>
